import { api } from './api';
export const castingApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // 获取项目的所有角色-演员绑定
        getProjectBindings: builder.query({
            query: (projectId) => `/projects/${projectId}/casting/bindings`,
            providesTags: (result, error, projectId) => [
                { type: 'Casting', id: projectId },
                'Casting',
            ],
        }),
        // 创建角色-演员绑定
        createBinding: builder.mutation({
            query: (data) => ({
                url: `/projects/${data.projectId}/casting/bindings`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: (result, error, { projectId }) => [
                { type: 'Casting', id: projectId },
                'Casting',
            ],
        }),
        // 更新绑定的妆造配置
        updateBinding: builder.mutation({
            query: ({ bindingId, makeupConfig }) => ({
                url: `/casting/bindings/${bindingId}`,
                method: 'PUT',
                body: { makeupConfig },
            }),
            invalidatesTags: (result) => result ? [{ type: 'Casting', id: result.projectId }, 'Casting'] : ['Casting'],
        }),
        // 删除绑定
        deleteBinding: builder.mutation({
            query: (bindingId) => ({
                url: `/casting/bindings/${bindingId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Casting'],
        }),
    }),
});
export const { useGetProjectBindingsQuery, useCreateBindingMutation, useUpdateBindingMutation, useDeleteBindingMutation, } = castingApi;
